<template>
  <section
    v-if="
      getUserProfile.freelancing &&
        getUserProfile.freelancing.status !== 2 &&
        getUserProfile.freelancing.status !== 4
    "
    class="freelancing-network"
  >
    <h1 class="title-header">Freelancing Network</h1>
    <p>
      If you are a freelancer or want to become one, you are welcome to join our Freelancing
      Network. Our platform connects you with top-tier technology companies while offering unmatched
      flexibility:
    </p>
    <ul class="list-unstyled">
      <li>
        Most of the projects we mediate are <strong>full-time</strong>, <strong>long-term</strong>,
        and <strong>fully remote</strong>
      </li>
      <li>
        We prioritize companies that work with modern tech stacks and offer
        <strong>exciting projects</strong>
      </li>
      <li>
        We actively match you with projects that align with your skills and interests, ensuring a
        diverse range of opportunities
      </li>
      <li>
        The most common positions that we have are within software development, design, technical
        operations, and technical support
      </li>
      <li>
        Your personal profile is safe with us — we never share your information with clients without
        your explicit consent
      </li>
      <li>When a relevant opportunity arises, we contact you directly</li>
      <li>
        You will work directly with our client using their collaboration tools just like you were an
        employee of theirs in the daily work
      </li>
      <li>We handle invoicing, and you’ll receive monthly payments based on your time reports.</li>
    </ul>
    <p>
      Haven't set up your personal company yet? No problem! You can still sign up with us, and we
      will assist you in managing payments and your taxes through one of our trusted partners.
    </p>
    <button
      @click="getUserProfile.completed ? openModal(1) : openModal(3)"
      class="btn btn-secondary"
    >
      Sign me up!
    </button>

    <CustomMainModal @close="closeModal" v-show="showModal">
      <template v-slot:header>
        <h5>
          Join Freelancing Network
        </h5>
      </template>
      <div v-if="modalType === 1">
        <div class="row">
          <div class="form-group m-label required-fixed-right">
            <input
              id="editName"
              type="text"
              class="form-control"
              v-model="companyName"
              placeholder="Enter your own name if you don't have a registered company"
            />
            <label for="editName">Company Name</label>
          </div>

          <div class="form-group m-label required-fixed-right">
            <input
              id="regno"
              type="text"
              class="form-control"
              v-model="registrationNumber"
              placeholder="Enter your social security/personal number if you don't have a registered company"
            />
            <label for="regno">Registration No</label>
          </div>

          <div class="form-group m-label">
            <input
              id="vat"
              type="text"
              class="form-control"
              v-model="vat"
              placeholder="Enter if applicable"
            />
            <label for="vat"
              ><span style="text-transform: uppercase!important;">EU VAT </span> number</label
            >
          </div>

          <div class="form-group m-label required-fixed-right">
            <input
              id="street"
              type="text"
              class="form-control"
              v-model="street"
              placeholder="Official address of company or home address if you don't have a registered company"
            />
            <label for="street">Street address</label>
          </div>

          <div class="form-group m-label col-md-4 required-fixed-right">
            <input
              id="postal"
              placeholder="Postal code"
              type="text"
              class="form-control"
              v-model="postal"
            />
            <label for="postal">Postal code</label>
          </div>
          <div class="form-group m-label filter-item col-md-8 required-right-city">
            <v-select
              v-model="city"
              label="name"
              :options="[...getCitiesListByCountry]"
              :reduce="city => city"
              :clearable="false"
              placeholder="City"
              @change="validate($event)"
              id="city"
            >
              <template v-slot:no-options>
                <div style="opacity: 0.5">You must choose country first</div>
              </template>
            </v-select>
            <label for="city">City</label>
          </div>
          <div class="form-group m-label filter-item col-md-12 required-right-city">
            <v-select
              v-model="country"
              @input="fetchCitisByCountryId($event)"
              :options="[...getAllCountries]"
              label="name"
              placeholder="Country"
              :reduce="country => country"
              :clearable="false"
              required
            />
            <!-- </FloatLabel> -->
            <label for="country">Country</label>
          </div>
        </div>
        <div class="modal-footer">
          <button @click="registerFreeLancer" class="btn btn-secondary">Submit</button>
          <button @click="closeModal" class="btn btn-primary">Cancel</button>
        </div>
      </div>
      <div v-if="modalType === 2">
        <div
          style="max-height:500px;
         padding-left:8%;
         padding-right:8%;
         padding-bottom: 30px;
         overflow-y:auto;"
          class="row"
        >
          <div class="col-md-12" v-html="previewContract()"></div>
          <div class="d-flex sign">
            <canvas ref="signaturePad" class="signature-pad"></canvas>
          </div>
          <div
            style="padding-left: 8%; padding-right: 8%; align-items: center; margin-top: 5px;"
            class="d-flex"
          >
            <span style="font-size: 13px;">Sign by drawing your signature in the yellow field</span>

            <button class="ms-auto btn btn-secondary" style="font-size: 13px;" @click="clear">
              Reset
            </button>
          </div>
        </div>
        <div class="modal-footer">
          <button
            v-if="signaturePad"
            :disabled="signaturePad._data.length === 0 || isLoading"
            @click="submitTemplate"
            class="btn btn-secondary"
          >
            Sign Agreement
          </button>
          <button @click="closeModal" class="btn btn-primary">Cancel</button>
        </div>
      </div>
      <div v-if="modalType === 3">
        <div class="row">
          <p style="text-align: center;">
            Please upload a CV or provide a link to your LinkedIn profile before you apply to join
            the Freelancing network.
          </p>
          <div class="modal-footer">
            <button @click="goToProfile" class="btn btn-secondary">Go to Profile Page</button>
            <button @click="closeModal" class="btn btn-primary">Cancel</button>
          </div>
        </div>
      </div>
      <Spinner :isLoading="isLoading" />
    </CustomMainModal>
  </section>

  <section v-else class="freelancing-network">
    <h1 class="title-header">Freelancing Network</h1>
    <p v-if="getUserProfile.freelancing">
      You joined our Freelancing network on
      {{
        getUserProfile.freelancing.signing_date
          | formatDate({
            format: getUserProfile.format_date,
            timezone: getUserProfile.timezone,
            hasHourAndMinutes: false,
          })
      }}
    </p>
    <div class="row">
      <div class="col-md-8">
        <ul
          v-if="getUserProfile.freelancing"
          style="list-style:none!important"
          class="list-unstyled stats"
        >
          <li><span>Company Name:</span> {{ getUserProfile.freelancing.company_name }}</li>
          <li>
            <span>Registration No:</span> {{ getUserProfile.freelancing.registration_number }}
          </li>
          <li><span>EU VAT number:</span> {{ getUserProfile.freelancing.eu_vat_number }}</li>
          <li><span>Street address:</span> {{ getUserProfile.freelancing.street_address }}</li>
          <li><span>Postal code:</span> {{ getUserProfile.freelancing.postal_code }}</li>
          <li><span>City:</span> {{ getUserProfile.freelancing.city.name }}</li>
          <li><span>Country:</span> {{ getUserProfile.freelancing.country.name }}</li>
        </ul>
      </div>
    </div>
    <button
      v-if="getUserProfile.freelancing"
      @click="onOpenDocPreview(getUserProfile.freelancing.fn_agreement_id)"
      class="btn btn-secondary"
    >
      Download Agreement
    </button>
  </section>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import CustomMainModal from '@/components/Modals/CustomMainModal';
import axios from 'axios';
import SignaturePad from 'signature_pad';
export default {
  components: {
    CustomMainModal,
  },
  data: () => ({
    signaturePad: null,
    signature: '',
    showModal: false,
    modalType: 0,
    isLoading: false,
    isDisabled: true,
    companyName: '',
    registrationNumber: '',
    vat: '',
    street: '',
    postal: '',
    currentDate: '',
    currentDateHours: '',
    city: {
      id: '',
      name: '',
    },
    country: {
      id: '',
      name: '',
      part_of_eu: '',
      phone_code: '',
      source: '',
    },
  }),
  methods: {
    ...mapActions([
      'editUserCandidateProfile',
      'retrieveUserProfile',
      'retrieveCompetencesList',
      'retrieveLanguagesList',
      'retrieveCandidateUserProfile',
      'retrieveCitiesListByCountryId',
      'retrieveAllCountries',
      'retrieveFreelancerDocumentPreview',
    ]),

    goToProfile() {
      this.$router.push({ name: 'user-profile' });
    },

    onOpenDocPreview(docId) {
      this.retrieveFreelancerDocumentPreview({ uuid: docId }).then(response => {
        const blob = new window.Blob([response.data], { type: 'application/pdf' });
        const fileURL = URL.createObjectURL(blob);
        window.open(fileURL);
      });
    },
    openModal(type) {
      this.setAvaiableData();
      this.modalType = type;
      this.showModal = true;
      this.$nextTick(() => {
        if (this.modalType === 2) {
          const canvas = this.$refs.signaturePad;
          if (canvas) {
            this.signaturePad = new SignaturePad(canvas);
            this.resizeCanvas();
            window.addEventListener('resize', this.resizeCanvas);
          }
        }
      });
    },
    closeModal() {
      this.showModal = false;
      this.companyName = '';
      this.registrationNumber = '';
      this.vat = '';
      this.street = '';
      this.postal = '';
    },
    nextStep(step) {
      this.modalType = step;
      this.$nextTick(() => {
        if (this.modalType === 2) {
          this.getCETDateHours();
          const canvas = this.$refs.signaturePad;
          if (canvas) {
            this.signaturePad = new SignaturePad(canvas, {
              penColor: 'rgb(66, 133, 244)',
            });
            this.resizeCanvas();
            window.addEventListener('resize', this.resizeCanvas);
          }
        }
      });
    },

    registerFreeLancer() {
      this.isLoading = true;
      let url = 'createfreelancer';
      if (this.getUserProfile.freelancing.length !== 0) {
        url = 'updatefreelancer';
      }
      axios({
        method: 'post',
        data: {
          company_name: this.companyName,
          registration_number: this.registrationNumber,
          eu_vat_number: this.vat,
          street_address: this.street,
          postal_code: this.postal,
          city_id: this.city.id,
          country_id: this.country.id,
        },
        url: `${process.env.VUE_APP_API_URL}/candidate/${url}`,
        headers: {
          Authorization: `Bearer ${localStorage.getItem(
            `${process.env.VUE_APP_TOKEN_PREFIX}token`,
          )}`,
        },
      })
        .then(res => {
          this.nextStep(2);
          this.retrieveCandidateUserProfile().then(() => {
            this.setAvaiableData();
          });
          this.isLoading = false;
        })
        .catch(err => {
          this.isLoading = false;
          this.$toasted.error('Please fill in all the required fields first.', {
            theme: 'bubble',
            icon: 'fa-check-circle',
            position: 'bottom-right',
            duration: 5000,
          });
        });
    },

    setAvaiableData() {
      if (this.getUserProfile.freelancing.street_address) {
        this.street = this.getUserProfile.freelancing.street_address;
      } else if (this.getUserProfile.street) {
        this.street = this.getUserProfile.street;
      }
      if (this.getUserProfile.freelancing.company_name) {
        this.companyName = this.getUserProfile.freelancing.company_name;
      }
      if (this.getUserProfile.freelancing.registration_number) {
        this.registrationNumber = this.getUserProfile.freelancing.registration_number;
      }
      if (this.getUserProfile.freelancing.eu_vat_number) {
        this.vat = this.getUserProfile.freelancing.eu_vat_number;
      }

      if (this.getUserProfile.freelancing.city) {
        this.city = this.getUserProfile.freelancing.city;
      } else this.city.name = this.getUserProfile.city;
      this.city.id = this.getUserProfile.city_id;

      if (this.getUserProfile.freelancing.country) {
        this.country = this.getUserProfile.freelancing.country;
      } else {
        this.country.id = this.getUserProfile.country_id;
        this.country.name = this.getUserProfile.country;
      }

      if (this.getUserProfile.freelancing.postal_code) {
        this.postal = this.getUserProfile.freelancing.postal_code;
      } else {
        this.postal = this.getUserProfile.postal;
      }
    },

    getCETDate() {
      const date = new Date();
      const options = {
        timeZone: 'Europe/Paris',
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit',
        hour12: false,
      };
      const formatter = new Intl.DateTimeFormat('en-GB', options);
      const parts = formatter.formatToParts(date);
      const year = parts.find(part => part.type === 'year').value;
      const month = parts.find(part => part.type === 'month').value;
      const day = parts.find(part => part.type === 'day').value;

      this.currentDate = `${year}-${month}-${day}`;
    },

    getCETDateHours() {
      const date = new Date();
      const options = {
        timeZone: 'Europe/Paris',
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit',
        hour12: false,
      };
      const formatter = new Intl.DateTimeFormat('en-GB', options);
      const parts = formatter.formatToParts(date);
      const year = parts.find(part => part.type === 'year').value;
      const month = parts.find(part => part.type === 'month').value;
      const day = parts.find(part => part.type === 'day').value;
      const hour = parts.find(part => part.type === 'hour').value;
      const minute = parts.find(part => part.type === 'minute').value;
      const second = parts.find(part => part.type === 'second').value;

      this.currentDateHours = `${year}-${month}-${day}-${hour}:${minute}`;
    },

    previewContract() {
      return `<!DOCTYPE html>
<html lang="en">
<head>
    <meta charset="UTF-8">
    <meta name="viewport" content="width=device-width, initial-scale=1.0">
    <title>Agreement for Consultancy Mediation Services</title>
    <style>
    @import url('https://fonts.googleapis.com/css2?family=Lato:ital,wght@0,100;0,300;0,400;0,700;0,900;1,100;1,300;1,400;1,700;1,900&display=swap');
        .freelancing-container {
           font-family: "Lato", sans-serif;
           padding-left:40px;
           padding-right:40px;
        }
        .freelancing-container p {
          font-size: 14px
        }
        .freelancing-container  h2 {
          font-size:18px;
          font-weight:800;
        }
        .freelancing-container  h3 {
          font-weight:800;
          font-size:13px;
          margin-bottom:20px;
          margin-top:20px;
        }

        .freelancing-container .flex {
          display:flex;
          justify-content: space-between;
          align-items: center;
        }

        .freelancing-container .flex img {
        width:50%;
        height:auto;
        }
    </style>
</head>
<body>
    <div class="freelancing-container">
    <img style="max-width:200px; margin-bottom:60px; margin-left:-80px; margin-top:30px" src="https://jobshark.eu/img/comstream-logo.af65b641.png" alt="Comstream logo" />
        <h2 style="margin-bottom:30px;">Agreement for Consultancy Mediation Services</h2>
        <p style="margin-bottom:25px;">
            This is an agreement between Comstream AB, a Swedish entity with registration number 556945-8911, hereinafter referred to as ”Comstream” and ${this.companyName}, an entity based in ${this.country.name} with registration number ${this.registrationNumber}, hereinafter referred to as “the Consultant” regarding consultancy mediation services, hereinafter “the Service”.
        </p>
        <h3>1. General Conditions</h3>
        <p class="section-title">1.1. The Consultant hereby appoints Comstream to find, qualify and present suitable consultancy opportunities, hereinafter ”Projects” to the Consultant.</p>
        <p class="section-title">1.2. The Consultant decides, on a case-by-case basis, which Projects that are of interest. By this confirmation, Comstream is granted the right to present the CV and other relevant information about the Consultant to the potential customer.</p>
        <p class="section-title">1.3. After acceptance by the customers, the Consultant shall use his/her best efforts to conduct the Project in a professional and timely manner.</p>
        <p class="section-title">1.4. Comstream is invoicing the customer for work conducted within the scope of the Project based on time reports provided by the Consultant.</p>
        <p class="section-title">1.5. If the Consultant is not a company that is eligible to enter B2B contracts, Comstream may refer the Consultant to a freelancing platform through which all monetary transactions will be formally conducted.</p>

        <h3>2. Responsibilities of the Parties</h3>
        <p class="section-title">2.1. Comstream shall use its best efforts to find suitable Projects for the Consultant.</p>
        <p class="section-title">2.2. It is the responsibility of the Consultant to provide Comstream with an updated CV, other relevant information about himself/herself and information about availability.</p>
        <p class="section-title">2.3. Comstream shall notify the Consultant when the customer has accepted the Project and appointed the Consultant. Participation in personal, video or phone meetings or other efforts made prior such an acceptance is conducted without compensation to the Consultant.</p>
        <p class="section-title">2.4. The Consultant shall use the time reporting system provided by Comstream on a daily basis.</p>
        <p class="section-title">2.5. The Consultant shall not, directly or indirectly, conduct work for the customer in any other way than what is governed by this agreement. If the Consultant would breach against this, Comstream is entitled to 50% of the corresponding amount but never less than 1.000 EUR per occasion.</p>

        <h3>3. Fees and Payment Terms</h3>
        <p class="section-title">3.1. The compensation is agreed on an hourly or monthly rate per Project.</p>
        <p class="section-title">3.2. Invoiced actual expenses, such as travelling costs, are forwarded to the customer without any upcharge by Comstream.</p>
        <p class="section-title">3.3. Unless otherwise is agreed for a particular Project, Comstream invoices customers monthly with payment terms of twenty (20) days.</p>
        <p class="section-title">3.4. Comstream is obliged to pay the Consultant within ten (10) days after the corresponding payment has been received from the customer and Comstream has received a valid invoice from the Consultant.</p>
        <p class="section-title">3.5. In case of delay of payment of amounts due, Comstream shall be obliged to pay penalty interest amounting to 12% per year. All mentioned fees are exclusive of VAT.</p>

        <h3>4. Termination</h3>
        <p class="section-title">4.1. Each Party may, at any time, terminate this Contract by one (1) month’s written notice.</p>
        <p class="section-title">4.2. A particular Project can be terminated by the customer with immediate effect at any time.</p>
        <p class="section-title">4.3. Comstream’s right to compensation according to this agreement is valid during the effective duration of the agreement and one (1) year thereafter.</p>

        <h3>5. Secrecy and Intellectual Property Rights</h3>
        <p class="section-title">5.1. Any information received by one party shall be treated as strictly confidential by the other party and the receiving party shall not communicate the information in any form to any third party.</p>
        <p class="section-title">5.2. All intellectual property rights for what is produced by the Consultant under this agreement shall be solely owned by the customer.</p>

        <h3>6. Processing of Personal Data</h3>
        <p class="section-title">6.1. To be able to provide the Service, Comstream gathers, processes and stores personal information about the Consultant. This includes, but is not limited to, CV, information about personal identity (name, address, phone number, e-mail, etc), competence areas, education, experience and civil status.</p>

        <h3>7. Limitation of Liability</h3>
        <p class="section-title">7.1. Comstream shall not, in any way, be considered as the employer for the Consultant.</p>
        <p class="section-title">7.2. Neither party is responsible for any indirect damages of any kind.</p>

        <h3>8. Applicable Laws</h3>
        <p class="section-title">8.1. This Contract shall be governed by the laws of Sweden and any dispute shall be settled by a general Swedish court of law.</p>
    </div>
</body>
</html>
`;
    },

    generateHtmlString() {
      return `<!DOCTYPE html>
<html lang="en">
<head>
    <meta charset="UTF-8">
    <meta name="viewport" content="width=device-width, initial-scale=1.0">
    <title>Agreement for Consultancy Mediation Services</title>
    <style>
    @import url('https://fonts.googleapis.com/css2?family=Lato:ital,wght@0,100;0,300;0,400;0,700;0,900;1,100;1,300;1,400;1,700;1,900&display=swap');
        .freelancing-container {
           font-family: "Lato", sans-serif;
           padding-left:40px;
           padding-right:40px;
        }
        .freelancing-container p {
          font-size: 14px
        }
        .freelancing-container  h2 {
          font-size:18px;
          font-weight:800;
        }
        .freelancing-container  h3 {
          font-weight:800;
          font-size:13px;
          margin-bottom:20px;
          margin-top:20px;
        }

        .freelancing-container .flex {
          display:flex;
          justify-content: space-between;
          align-items: center;
        }

        .freelancing-container .flex img {
        width:50%;
        height:auto;
        }
    </style>
</head>
<body>
    <div class="freelancing-container">
    <img style="max-width:200px; margin-bottom:60px; margin-left:-50px; margin-top:30px" src="https://jobshark.eu/img/comstream-logo.af65b641.png" alt="Comstream logo" />
        <h2 style="margin-bottom:30px;">Agreement for Consultancy Mediation Services</h2>
        <p style="margin-bottom:25px;">
            This is an agreement between Comstream AB, a Swedish entity with registration number 556945-8911, hereinafter referred to as ”Comstream” and ${this.companyName}, an entity based in ${this.country.name} with registration number ${this.registrationNumber}, hereinafter referred to as “the Consultant” regarding consultancy mediation services, hereinafter “the Service”.
        </p>
        <h3>1. General Conditions</h3>
        <p class="section-title">1.1. The Consultant hereby appoints Comstream to find, qualify and present suitable consultancy opportunities, hereinafter ”Projects” to the Consultant.</p>
        <p class="section-title">1.2. The Consultant decides, on a case-by-case basis, which Projects that are of interest. By this confirmation, Comstream is granted the right to present the CV and other relevant information about the Consultant to the potential customer.</p>
        <p class="section-title">1.3. After acceptance by the customers, the Consultant shall use his/her best efforts to conduct the Project in a professional and timely manner.</p>
        <p class="section-title">1.4. Comstream is invoicing the customer for work conducted within the scope of the Project based on time reports provided by the Consultant.</p>
        <p class="section-title">1.5. If the Consultant is not a company that is eligible to enter B2B contracts, Comstream may refer the Consultant to a freelancing platform through which all monetary transactions will be formally conducted.</p>

        <h3>2. Responsibilities of the Parties</h3>
        <p class="section-title">2.1. Comstream shall use its best efforts to find suitable Projects for the Consultant.</p>
        <p class="section-title">2.2. It is the responsibility of the Consultant to provide Comstream with an updated CV, other relevant information about himself/herself and information about availability.</p>
        <p class="section-title">2.3. Comstream shall notify the Consultant when the customer has accepted the Project and appointed the Consultant. Participation in personal, video or phone meetings or other efforts made prior such an acceptance is conducted without compensation to the Consultant.</p>
        <p class="section-title">2.4. The Consultant shall use the time reporting system provided by Comstream on a daily basis.</p>
        <p class="section-title">2.5. The Consultant shall not, directly or indirectly, conduct work for the customer in any other way than what is governed by this agreement. If the Consultant would breach against this, Comstream is entitled to 50% of the corresponding amount but never less than 1.000 EUR per occasion.</p>

        <h3>3. Fees and Payment Terms</h3>
        <p class="section-title">3.1. The compensation is agreed on an hourly or monthly rate per Project.</p>
        <p class="section-title">3.2. Invoiced actual expenses, such as travelling costs, are forwarded to the customer without any upcharge by Comstream.</p>
        <br/><br/>
        <p class="section-title">3.3. Unless otherwise is agreed for a particular Project, Comstream invoices customers monthly with payment terms of twenty (20) days.</p>
        <p class="section-title">3.4. Comstream is obliged to pay the Consultant within ten (10) days after the corresponding payment has been received from the customer and Comstream has received a valid invoice from the Consultant.</p>
        <p class="section-title">3.5. In case of delay of payment of amounts due, Comstream shall be obliged to pay penalty interest amounting to 12% per year. All mentioned fees are exclusive of VAT.</p>

        <h3>4. Termination</h3>
        <p class="section-title">4.1. Each Party may, at any time, terminate this Contract by one (1) month’s written notice.</p>
        <p class="section-title">4.2. A particular Project can be terminated by the customer with immediate effect at any time.</p>
        <p class="section-title">4.3. Comstream’s right to compensation according to this agreement is valid during the effective duration of the agreement and one (1) year thereafter.</p>

        <h3>5. Secrecy and Intellectual Property Rights</h3>
        <p class="section-title">5.1. Any information received by one party shall be treated as strictly confidential by the other party and the receiving party shall not communicate the information in any form to any third party.</p>
        <p class="section-title">5.2. All intellectual property rights for what is produced by the Consultant under this agreement shall be solely owned by the customer.</p>

        <h3>6. Processing of Personal Data</h3>
        <p class="section-title">6.1. To be able to provide the Service, Comstream gathers, processes and stores personal information about the Consultant. This includes, but is not limited to, CV, information about personal identity (name, address, phone number, e-mail, etc), competence areas, education, experience and civil status.</p>

        <h3>7. Limitation of Liability</h3>
        <p class="section-title">7.1. Comstream shall not, in any way, be considered as the employer for the Consultant.</p>
        <p class="section-title">7.2. Neither party is responsible for any indirect damages of any kind.</p>

        <h3>8. Applicable Laws</h3>
        <p class="section-title">8.1. This Contract shall be governed by the laws of Sweden and any dispute shall be settled by a general Swedish court of law.</p>
          <div> 
          <p style="margin-bottom:0px;" class="section-title">
              ${this.city.name}, ${this.country.name} on ${this.currentDate}		
              </p>
              <p style="margin-bottom:0px;" class="section-title">
              ${this.companyName}		
              </p>
               <img style="width: 240px; height: 75px; object-fit: contain;" src="${this.signature}"/>
               <p style="margin-top:-6px;">
              ${this.getUserProfile.first_name} ${this.getUserProfile.last_name}	
              </p>
              <div style="margin-top:-5px;">
              <span style="font-size:12px; margin-top:-12px;">This agreement was digitally signed on CET ${this.currentDateHours} by ${this.getUserProfile.email}.</span>
              </div>
        </div>
    </div>
</body>
</html>
`;
    },

    submitTemplate() {
      this.isLoading = true;
      this.save();
      let htmlContent = this.generateHtmlString();
      let requestData = JSON.stringify({
        htmlContent: htmlContent,
      });
      const formData = new FormData();
      formData.append('html', requestData);
      formData.append('signature', this.signature);
      formData.append('signing_date', this.currentDate);
      axios({
        method: 'post',
        data: formData,
        url: `${process.env.VUE_APP_API_URL}/candidate/generatepdf`,
        headers: {
          Authorization: `Bearer ${localStorage.getItem(
            `${process.env.VUE_APP_TOKEN_PREFIX}token`,
          )}`,
          'Content-Type': 'multipart/form-data',
          'Cache-Control': 'no-cache',
        },
      })
        .then(response => {
          this.isLoading = false;
          this.retrieveCandidateUserProfile();
          this.closeModal();
        })
        .catch(error => {
          this.isLoading = false;
        });
    },

    fetchCitisByCountryId(id) {
      this.city = '';
      this.retrieveCitiesListByCountryId({
        id: this.country.id,
      });
    },
    fetchCitisByCountryIdInitial(id) {
      this.retrieveCitiesListByCountryId({
        id: this.country.id,
      });
    },
    resizeCanvas() {
      const canvas = this.$refs.signaturePad;
      const ratio = Math.max(window.devicePixelRatio || 1, 1);
      canvas.width = canvas.offsetWidth * ratio;
      canvas.height = canvas.offsetHeight * ratio;
      canvas.getContext('2d').scale(ratio, ratio);
      this.signaturePad.clear();
    },
    clear() {
      this.signaturePad.clear();
    },
    save() {
      if (this.signaturePad.isEmpty()) {
        alert('Please provide a signature first.');
      } else {
        this.signature = this.signaturePad.toDataURL();
      }
    },
  },
  computed: {
    ...mapGetters([
      'getUserProfile',
      'getNotificationMessage',
      'isTokenExpired',
      'getCandidateDocuments',
      'getCompetencesFilterList',
      'getLanguagesList',
      'getAllCountries',
      'getCitiesListByCountry',
    ]),
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.resizeCanvas);
  },
  mounted() {
    this.getCETDate();
  },
};
</script>

<style lang="scss" scoped>
@import '@/assets/scss/_variables';
.title-header {
  font-family: Montserrat, Roboto, 'Helvetica Neue', Arial, sans-serif;
  font-weight: bolder;
  font-size: 1.9rem;
  margin: 30px 0 20px 0;
}
.freelancing-network {
  font-family: $font-family-sans-lato;
  padding: 20px;
  .list-unstyled {
    list-style: disc !important;
    li {
      margin-left: 35px !important;
    }
  }
  .modal-footer {
    display: flex;
    justify-content: center;
  }

  .signature-pad {
    background: #fcf3b6;
    width: 100%;
    height: 170px;
  }

  .sign {
    justify-content: space-between;
    align-items: center;
    padding-left: 8%;
    padding-right: 8%;
  }

  .form-group.required-fixed-right {
    position: relative;
    &:after {
      content: '*';
      font-size: 22px;
      position: absolute;
      top: 11px;
      right: 25px;
      color: red;
      opacity: 0.6;
    }
  }

  .form-group.required-right-city {
    position: relative;
    &:after {
      content: '*';
      font-size: 22px;
      position: absolute;
      top: 3px;
      right: 25px;
      color: red;
      opacity: 0.6;
    }
  }

  .stats {
    list-style: none;
    li {
      font-size: 14px;

      margin-left: 0 !important;
      display: flex;
      flex: 1;
      padding: 10px 0 10px 0;
      border-bottom: 1px solid #ddd;
      span {
        font-weight: 600;
        min-width: 110px;
        margin-right: 20px;
        display: inline-block;
      }
    }
  }
}
</style>
